import React, { useContext, useState } from "react";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserService from "../../../../services/UserService";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IOnGetAllCategoryQtySalesReportDTO from "../../../../models/DTO/IOnGetAllCategoryQtySalesReportDTO";
import { NumericFormat } from "react-number-format";
import ExcelJS from "exceljs/dist/exceljs.min.js";
import UIService from "../../../../services/UIService";
import moment from "moment";
import "./CategoryQtySalesReport.scss";

type Props = {
    processedReport: IProcessed_Report;
};

export const CategoryQtySalesReport = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [reportData, setReportData] = useState<IOnGetAllCategoryQtySalesReportDTO>(
        props.processedReport.report_data as IOnGetAllCategoryQtySalesReportDTO
    );

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet(`Report Data`);

            const columns: (
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
            )[] = [
                { header: "Category", key: "category" },
                { header: "Total Qty.", key: "total_qty" },
                { header: "Total", key: "total" },
            ];

            ws.columns = columns;

            ws.getCell("A1").font = {
                bold: true,
            };

            ws.getCell("B1").font = {
                bold: true,
            };

            ws.getCell("C1").font = {
                bold: true,
            };

            ws.getCell("D1").font = {
                bold: true,
            };

            for (const categoryName of Object.keys(reportData.categories)) {
                // @ts-expect-error
                const detail = reportData.categories[categoryName];
                const category = detail.categoryName;
                const total_qty = detail.totalQtySold;
                const total = detail.amount;

                ws.addRow({ category, total_qty, total });
            }

            const totalRow = ws.addRow({
                total_qty: reportData.totalQtySold,
                total: reportData.totalAmount,
            });
            totalRow.font = {
                bold: true,
            };
            totalRow.border = {
                top: {
                    style: "thick",
                },
            };

            // const periodStart = moment(reportData.periodStart).format("YYYY-MM-DD");
            // const periodEnd = moment(reportData.periodEnd).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `orderwerks-category-qty-report-${UserService.parseLastUpdated(props.processedReport.created_at)}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    const tableDark = UIService.isMainViewLight() ? "" : "table-dark";

    return (
        <div className={"CategoryQtySalesReport"}>
            {reportData && reportData.totalAmount > 0 ? (
                <OwButton
                    leftIconClass={"fad fa-file-excel"}
                    className={"btn-primary d-print-none"}
                    title={"export_to_excel"}
                    fn={downloadExcel}
                />
            ) : null}
            <div>
                <OwTitle title={"category_qty_sales_report"} tag={"h3"} />
                <OwLabel title={"created_at"} postText={":"} className={"me-2"} />
                {UserService.parseLastUpdated(props.processedReport.created_at)}
            </div>

            <div className={"mt-3"}>
                {moment(reportData.startDate).format("MM/DD/YYYY")} - {moment(reportData.endDate).format("MM/DD/YYYY")}
            </div>

            <div>
                <table className={`table table-sm ${tableDark}`}>
                    <thead>
                        <tr>
                            <th scope={"col"}>
                                <OwLabel title={"category"} />
                            </th>
                            <th className={"text-end"} scope={"col"}>
                                <OwLabel title={"total_qty"} />
                            </th>
                            <th className={"text-end"} scope={"col"}>
                                <OwLabel title={"total_amount"} />
                            </th>
                        </tr>
                    </thead>
                    {Object.keys(reportData.categories).map((categoryName) => {
                        return (
                            <tbody key={categoryName}>
                                <tr>
                                    <td>{categoryName}</td>
                                    <td className={"text-end"}>
                                        <NumericFormat
                                            value={reportData.categories[categoryName].totalQtySold}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={supplierModel.pricing_precision || 2}
                                            fixedDecimalScale={true}
                                        />
                                    </td>
                                    <td className={"text-end"}>
                                        <NumericFormat
                                            value={reportData.categories[categoryName].amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={supplierModel.pricing_precision || 2}
                                            fixedDecimalScale={true}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}

                    <tbody>
                        <tr>
                            <td></td>
                            <td className={"text-end"}>
                                <b>
                                    <NumericFormat
                                        value={reportData.totalQtySold}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={supplierModel.pricing_precision || 2}
                                        fixedDecimalScale={true}
                                    />
                                </b>
                            </td>
                            <td className={"text-end"}>
                                <b>
                                    <NumericFormat
                                        value={reportData.totalAmount}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={supplierModel.pricing_precision || 2}
                                        fixedDecimalScale={true}
                                    />
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
